var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentWorkflowStatus)?_c('v-chip',{attrs:{"small":"","outlined":"","color":_vm.$Color().colorFor(_vm.currentWorkflowStatusColor)}},[_vm._v(" "+_vm._s(_vm.workflowStatusText)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }